import './App.css';
import CameraWindow from './components/CameraWindow';
// import { Client } from "@gradio/client";

function App() {
  return (
    <div className="App">
      <h1>Simple Math Solver</h1>
      <CameraWindow />
    </div>
  );
}

export default App;